import type { ComponentProps } from 'react';
import styled from 'styled-components';
import { Dropdown } from 'react-bootstrap';

import { basic } from '../../theme/colors';

/* atoms for AddPlateModal plate matching and text input */
export const PlateMatchingRow = styled.div`
  display: flex;
  gap: 16px;
`;

export const RadioRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  height: 38px;
`;

export const PlateInputColumn = styled.div`
  flex: 1;
`;

/* atoms for AddPlateModal event type dropdown */
export const DropdownTrigger = styled.button.attrs({
  type: 'button',
  'aria-haspopup': 'menu',
  'data-test': 'permitted-plate-event-types-trigger',
})`
  width: 100%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0.375rem 0.75rem;
  border: 1px solid ${basic.haydenLightSteel2};
  border-radius: 0.25rem;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  cursor: pointer;
`;

/* atoms for RegionSelector dropdown */
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
`;

export const StyledToggle = styled(Dropdown.Toggle)`
  width: 100%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  border-color: ${basic.haydenLightSteel2};
  background-color: ${basic.haydenWhite};
  color: ${basic.haydenDarkSand2};
  display: flex;
  justify-content: space-between;
  align-items: center;

  &::after {
    display: none;
  }

  &:hover,
  &:focus,
  &:active,
  &.dropdown-toggle:focus,
  &.dropdown-toggle:active,
  &:not(:disabled):not(.disabled):active,
  &[aria-expanded='true'] {
    background-color: ${basic.haydenWhite} !important;
    border-color: ${basic.haydenLightSteel2} !important;
    color: ${basic.haydenDarkSand2} !important;
    box-shadow: none !important;
  }

  &.show {
    box-shadow: none !important;
  }
`;

export const FlyoutMenu = styled(Dropdown.Menu).attrs(
  (props: ComponentProps<typeof Dropdown.Menu>) => ({
    /* Popper `fixed` helps menus escape clipped / scrollable ancestors (e.g. AddPlate modal body). */
    popperConfig: {
      ...(props.popperConfig ?? {}),
      strategy: 'fixed' as const,
    },
  }),
)`
  &&.show {
    display: flex;
  }
  padding: 0;
  min-width: auto;
`;

export const GroupsPane = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding: 8px;
  min-width: 280px;
`;

export const StatesPane = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding: 8px;
  min-width: 180px;
  border-left: 1px solid ${basic.haydenLightSteel2};
`;

export const GroupItem = styled.button<{ $active: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 1rem;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  border: none;
  font: inherit;
  color: inherit;
  text-align: left;
  background-color: ${({ $active }) => (
    $active
      ? basic.haydenHover
      : 'transparent'
  )};

  &:hover,
  &:focus {
    background-color: ${basic.haydenHover};
  }
`;
